import { customQuestionsApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CUSTOM_QUESTIONS_ACTION_TYPE = createNamedActions('customQuestions', {
  GET_CUSTOM_QUESTIONS: 'GET_CUSTOM_QUESTIONS',
  EDIT_CUSTOM_QUESTION: 'EDIT_CUSTOM_QUESTION',
  CREATE_CUSTOM_QUESTION: 'CREATE_CUSTOM_QUESTION',
  DELETE_CUSTOM_QUESTION: 'DELETE_CUSTOM_QUESTION',
  GET_CUSTOM_QUESTIONS_SCHEMA: 'GET_CUSTOM_QUESTIONS_SCHEMA',
});

const customQuestionSchema = new schema.Entity('data', {}, { idAttribute: 'customQuestionId' });

export const setCustomQuestionsAction = customQuestionsList => ({
  type: CUSTOM_QUESTIONS_ACTION_TYPE.GET_CUSTOM_QUESTIONS,
  payload: normalize(customQuestionsList, [customQuestionSchema]).entities.data,
});

export const getCustomQuestionsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await customQuestionsApi.getCustomQuestions();

  return dispatch(setCustomQuestionsAction(data));
});

export const editCustomQuestionsAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await customQuestionsApi.editCustomQuestions(body);

  return dispatch({
    type: CUSTOM_QUESTIONS_ACTION_TYPE.EDIT_CUSTOM_QUESTION,
    payload: data,
  });
});

export const deleteCustomQuestionAction = catchAsyncActionError(
  ({ customQuestionId }) =>
    async dispatch => {
      await customQuestionsApi.deleteCustomQuestions({ customQuestionId });

      return dispatch({
        type: CUSTOM_QUESTIONS_ACTION_TYPE.DELETE_CUSTOM_QUESTION,
        payload: customQuestionId,
      });
    },
);

export const createCustomQuestionsAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await customQuestionsApi.createCustomQuestions(body);

  await dispatch(getCustomQuestionsAction());

  return dispatch({
    type: CUSTOM_QUESTIONS_ACTION_TYPE.CREATE_CUSTOM_QUESTION,
    payload: data,
  });
});

export const getCustomQuestionsSchemaAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await customQuestionsApi.getCustomQuestionsExpressionEngineSchema();

  return dispatch({
    type: CUSTOM_QUESTIONS_ACTION_TYPE.GET_CUSTOM_QUESTIONS_SCHEMA,
    payload: data,
  });
});

const editCustomQuestionsSortOrderAction = catchAsyncActionError(
  body => async () => await customQuestionsApi.editCustomQuestionsSortOrder(body),
);

export const reorderCustomQuestionsListAction =
  ({ reorderedCustomQuestions }) =>
  dispatch => {
    const reorderedIdsList = reorderedCustomQuestions.map(
      ({ customQuestionId }) => customQuestionId,
    );

    dispatch(setCustomQuestionsAction(reorderedCustomQuestions));

    return dispatch(editCustomQuestionsSortOrderAction(reorderedIdsList));
  };

export const getCustomQuestionsByCustomQuestionIdAction = catchAsyncActionError(
  params => async () => await customQuestionsApi.getCustomQuestionsByCustomQuestionId(params),
);
